/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect, useState } from 'react'

const useDetectMobileKeyboard = (minKeyboardHeight = 300, defaultValue = false) => {
  const [isMobileKeyboardOpen, setIsMobileKeyboardOpen] = useState(defaultValue)

  useEffect(() => {
    const listener = () => {
      // @ts-ignore
      const newState = window.screen.height - minKeyboardHeight > window.visualViewport.height
      setIsMobileKeyboardOpen(newState)
    }
    // @ts-ignore
    window.visualViewport.addEventListener('resize', listener)
    return () => {
      // @ts-ignore
      window.visualViewport.removeEventListener('resize', listener)
    }
  }, [])

  return isMobileKeyboardOpen
}

export default useDetectMobileKeyboard
